(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tgf-quick-view"] && !Shopify.designMode) return;
  try {
    if (!window.tgfQuickViewBound) {
    window.tgfQuickViewBound = true;

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-tgf-quick-view-open]');
      if (openButton) {
        event.preventDefault();
        event.stopPropagation();
        const dialog = document.getElementById(openButton.dataset.tgfQuickViewOpen);
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-tgf-quick-view-close]');
      if (closeButton) {
        event.preventDefault();
        closeButton.closest('dialog')?.close();
        return;
      }

      if (event.target instanceof HTMLDialogElement && event.target.classList.contains('tgf-quick-view')) {
        const bounds = event.target.getBoundingClientRect();
        const isOutside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;
        if (isOutside) event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
